<template>
  <div class="container_fluid">
    <div class="content" ref="content" style="margin: 0 auto">
      <!--banner輪播圖-->
      <div class="banner_style">
        <el-carousel indicator-position="outside" class="banner" :style="bannerimg">
          <el-carousel-item v-for="(item,index) in banners" :key="index">
            <img v-if="is_language_en" :style="bannerimg" :src="item.path_en && item ? (imgUrl + item.path_en ): ''" alt=""
                 @click="onBannerClick(item)">
            <img v-else :style="bannerimg" :src="item.path && item ? (imgUrl + item.path ): ''" alt=""
                 @click="onBannerClick(item)">
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--產品類別-->
      <div class="productCategory">
        <div class="container clear" style="height: 530px;margin-top: 37px;margin-bottom:53px ">
          <!--男士珠宝-->
          <div class="l" style="width:365px;height:100%;margin-right: 39px;position:relative">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_men.png')" alt="">
            <div class="type_layout">
              <div class="nameE ">MENS JEWELRY</div>
              <div class="nameC">男士珠寶</div>
              <router-link class="searchMore" tag="div" :to="{name:'Search',query:{type:'series40'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
          <!--  对戒-->
          <div class="l" style="width:366px;height:100%;margin-right: 39px;position:relative">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_wedding_ring.png')" alt="">
            <div class="type_layout">
              <div class="nameE ">WEDDING RING</div>
              <div class="nameC">婚戒&對戒</div>
              <router-link class="searchMore" tag="div" :to="{name:'Search',query:{type:'series39'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
          <!--综合-->
          <div class="l" style="width:391px;height:100%;position:relative">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_all.png')" alt="">
            <div class="type_layout">
              <div class="nameE" style="font-size: 14px;">NEW JEWELRY FOR EQUIVALENT WEAR</div>
              <div class="nameC" style="font-size: 24px;margin-bottom: 32px;">全新首飾 · 等價換戴</div>
              <router-link class="searchMore" tag="div" :to="{name:'Search',query:{type:'reco'}}">
                <div>
                  {{$t('mall_home.all')}}<!-- 查看所有 -->
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="container clear" style="height: 546px;margin-bottom: 50px">
          <!--戒指-->
          <div class="l" style="width:297px;height:100%;position:relative;margin-right: 4px">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_rg.png')" alt="">
            <div class="type_layout2">
              <div class="nameE2 ">RING</div>
              <div class="nameC2">戒指</div>
              <router-link class="searchMore2" tag="div" :to="{name:'Search',query:{type:'rg'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
          <!-- 耳環 -->
          <div class="l" style="width:297px;height:100%;position:relative;margin-right: 4px">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_earrings.png')" alt="">
            <div class="type_layout2">
              <div class="nameE2 ">EARRINGS</div>
              <div class="nameC2">耳飾</div>
              <router-link class="searchMore2" tag="div" :to="{name:'Search',query:{type:'er'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
          <!-- 項鏈/吊坠-->
          <div class="l" style="width:297px;height:100%;position:relative;margin-right: 4px">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_necklace_pendant.png')" alt="">
            <div class="type_layout2">
              <div class="nameE2 ">NECKLACE & PENDANT</div>
              <div class="nameC2">項鏈&吊墜</div>
              <router-link class="searchMore2" tag="div" :to="{name:'Search',query:{type:'nl_pd'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
          <!--  手鏈/手鐲 -->
          <div class="l" style="width:297px;height:100%;position:relative">
            <img style="width:100%;height:100%"
                 :src="require('@/assets/homeImg/jewellery_home_bracelet.png')" alt="">
            <div class="type_layout2">
              <div class="nameE2 ">BRACELET</div>
              <div class="nameC2">手鏈&手鐲</div>
              <router-link class="searchMore2" tag="div" :to="{name:'Search',query:{type:'bl_bg'}}">
                <div>{{$t('mall_home.shop')}}</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="head productCategory" style="margin-bottom: 130px ">
        <div class="title">
          JEWELLERY-BOX ·
          {{ $t('mall_home.new_collection') }}
          <!--          全新系列-->
        </div>
        <div class="description">
          {{ $t('mall_home.exchange') }}
          <!--          搜飾盒珠寶無限換戴-->
        </div>
      </div>

      <!--   全新系列   -->
      <ul class="container clear">
        <router-link :to="{name:'Search',query:{type:'series'+series.id}}" tag="li"
                     v-for="(series,index) in productSeriesList" :key="series.id"
                     class="series_style"
                     :style="(index%3===1)?'margin-left:39px;margin-right: 39px':''">
          <div class="series_style_content"
               :style="(index%3===1)?'margin-top:78px':''">
            <img v-if="is_language_en" :src="series.mini_path_en && series ? (imgUrl + series.mini_path_en ): ''" style="width: 100%;height:100% ">
            <img v-else :src="series.mini_path && series ? (imgUrl + series.mini_path ): ''" style="width: 100%;height:100% ">
            <div class="series_style_text">
              - {{ series.title }} -
            </div>
          </div>
        </router-link>
      </ul>

      <div class="head productCategory">
        <div class="title">
          {{ $t('mall_home.find_store') }}
          <!--          前往附近的體驗中心-->
        </div>
        <div class="description">
          {{ $t('mall_home.explore_products') }}
          <!--          更多體驗等妳來-->
        </div>
      </div>

      <!--門店地址banner-->
      <div class="storeChoose container">
        <div class="chooseBox ">
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item class="chooseBanner">
              <img style="width: 100%;height: 100%" :src="this.store_address.hk"
                   alt="">
            </el-carousel-item>
            <el-carousel-item class="chooseBanner">
              <img style="width: 100%;height: 100%" :src="this.store_address.mm"
                   alt="">
            </el-carousel-item>
            <el-carousel-item class="chooseBanner">
              <img style="width: 100%;height: 100%" :src="this.store_address.py"
                   alt="">
            </el-carousel-item>
            <el-carousel-item class="chooseBanner">
              <img style="width: 100%;height: 100%" :src="this.store_address.qz"
                   alt="">
            </el-carousel-item>
            <el-carousel-item class="chooseBanner">
              <img style="width: 100%;height: 100%" :src="this.store_address.ss"
                   alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div style="margin-bottom: 60px"></div>
    </div>
  </div>

</template>

<script>
  var speed = 5;
  // import Vue from 'vue'
  // import {Carousel,CarouselItem} from 'element-ui';
  // Vue.use(Carousel).use(CarouselItem);   bbn
  import baseUrl from '@/api/baseUrl.js'

  export default {
    name: "JewelleryHome.vue",
    data() {
      return {
        bannerimg: {
          width: '100%',
          height: '0px'
        },
        itemW: 0,
        flag: false,
        offset: 0,
        timer: null,
        curr: 0,
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        area: 440300,
        isShow: false,
        // paddingNum: '',
        widthNum: '',
        heightNum: '',
        mr: '',
        hotTop: 0,
        imgUrl: baseUrl.imgUrl,
        banners: [],
        productSeriesList: [],
        is_language_en: this.$i18n.locale === "en",
        store_address: {
          hk: '',
          mm: '',
          ss: '',
          qz: '',
          py: ''
        }
      };
    },
    created() {
      let aa = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      // console.log("windowWidth:", aa);
      if (aa > 1500) {
        aa = 1500;
      } else if (aa <= 1200) {
        aa = 1200;
      }
      this.bannerimg.height = aa * 0.4 + 'px';
    },
    mounted() {
      this.initStoreAddress()
      this.getBanner();
      // this.getCategory();
      this.getSeries();
    },

    methods: {
      //初始化商店地址
      initStoreAddress() {
        var baseUrl = 'https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/home/';
        var spand = this.is_language_en ? '_en' : '';
        this.store_address.hk = baseUrl + 'home_banner_store_hk' + spand + '.png';
        this.store_address.mm = baseUrl + 'home_banner_store_mm' + spand + '.png';
        this.store_address.ss = baseUrl + 'home_banner_store_ss' + spand + '.png';
        this.store_address.qz = baseUrl + 'home_banner_store_qz' + spand + '.png';
        this.store_address.py = baseUrl + 'home_banner_store_py' + spand + '.png';
      },
      //獲取banner
      getBanner() {
        this.$axios.get('mall_api/get_banner', {}).then(res => {
          // console.log("getBanner",res.data.data);
          this.banners = res.data.data;
        })
      },

      //獲取產品系列
      getSeries() {
        this.$axios.get('mall_api/get_product_series', {}).then(res => {
          // this.productType = res.data.data;
          // console.log("productSeriesList::", res.data.data.series);
          this.productSeriesList = res.data.data.series;
        });
      },

      //banner跳轉
      onBannerClick(banner) {
        // console.log("bannerClick:  ", banner)
        var type = banner.on_click;
        switch (type) {
          case 'w': //網頁
            var url = banner.on_click_target;
            if (url.indexOf("http") > -1) {
              window.open(url);
            }
            break
          case 'p': //產品
            this.$router.push({
              name: "Product",
            });
            break
        }
      },
    },

  }
</script>


<style scoped>
  .head {
    padding-top: 98px;
    padding-bottom: 28px;
  }

  /*banner圖*/
  .banner_style {
    min-width: 1200px;
    max-width: 1500px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  .productCategory {
    text-align: center;
    color: #1E1303;
    font-size: 22px;
  }

  .description {
    color: #5B5957;
    font-size: 22px;
  }

  .type_layout {
    width: 360px;
    position: absolute;
    bottom: 42px;
    left: 50%;
    margin-left: -180px;
    text-align: center;
  }

  .type_layout2 {
    width: 280px;
    position: absolute;
    bottom: 87px;
    left: 50%;
    margin-left: -140px;
    text-align: center;
  }

  .nameE {
    font-size: 20px;
    color: white;
    font-family: 'MySongTi'
  }

  .nameE2 {
    font-size: 20px;
    color: black;
    font-family: 'MySongTi'
  }

  .nameC {
    font-size: 16px;
    color: white;
    margin-top: 4px;
    margin-bottom: 35px;
    font-family: 'MySongTi'
  }

  .nameC2 {
    font-size: 16px;
    color: black;
    margin-top: 4px;
    margin-bottom: 35px;
    font-family: 'MySongTi'
  }

  .searchMore {
    display: inline-block;
    font-size: 14px;
    width: 100px;
    padding: 7px 0;
    border: 1px solid #FFFFFF;
    color: white;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  .searchMore2 {
    display: inline-block;
    font-size: 14px;
    width: 100px;
    padding: 7px 0;
    border: 1px solid #1E1303;
    color: #1E1303;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    margin-top: 38px;
    cursor: default;
  }

  .type_first_img:hover {
    cursor: pointer
  }

  .searchMore:hover {
    background: white;
    color: black;
    cursor: pointer
  }

  .searchMore2:hover {
    background: black;
    color: white;
    cursor: pointer
  }

  .title, .content {
    color: #1E1303;
  }

  .title {
    font-size: 36px;
    font-family: 'MySongTi'
  }

  .content {
    font-size: 13px;
    margin-bottom: 0;
  }

  /*門店選取*/
  .storeChoose {
    background-color: #E8E1D8;
    height: 429px;
    position: relative;
  }

  .chooseBanner {
    width: 100%;
  }

  .chooseBanner > img {
    width: 100%;
    /*height: 100%;*/
  }

  .chooseBox {
    position: absolute;
    width: 100%;
    top: 5px;
    left: 5px;
  }

  .series_style {
    width: 374px;
    height: 588px;
    margin-bottom: 52px;
    float: left;
  }

  .series_style_content {
    width: 100%;
    height: 510px;
    position: relative;
  }

  .series_style_text {
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0px;
    text-align: center;
    font-size: 24px;
    padding: 19px 0;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    display: none;
  }

  .series_style:hover .series_style_text {
    display: block;
    cursor: pointer
  }


</style>



// WEBPACK FOOTER //
// src/views/viewHK/JewelleryHome.vue